import { useQuery } from "@tanstack/react-query";
import { Navigate, useLocation } from "react-router-dom";

import { Button } from "@/components/ui";
import { Splash } from "@/components/common";
import {
  fetchOnboardingStatus,
  ONBOARDING_QUERY_KEY,
} from "@/services/onboarding";

interface RequireOnboardingProps {
  children: React.ReactElement;
}

export function RequireOnboarding({ children }: RequireOnboardingProps) {
  const location = useLocation();
  const isOnboardingRoute = location.pathname === "/onboarding";
  const onboardingQuery = useQuery({
    queryKey: ONBOARDING_QUERY_KEY,
    queryFn: fetchOnboardingStatus,
    retry: false,
    enabled: !isOnboardingRoute,
  });

  if (isOnboardingRoute) {
    return children;
  }

  if (onboardingQuery.isLoading) {
    return <Splash />;
  }

  if (onboardingQuery.isError || !onboardingQuery.data) {
    return <div className="mx-auto max-w-md space-y-4 p-6">
      <p role="alert">Não foi possível confirmar a configuração da clínica.</p>
      <Button variant="outline" disabled={onboardingQuery.isFetching} onClick={() => void onboardingQuery.refetch()}>
        {onboardingQuery.isFetching ? "Consultando…" : "Tentar novamente"}
      </Button>
    </div>;
  }

  if (
    onboardingQuery.data &&
    !onboardingQuery.data.is_completed
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
